<div class="row">
    <div class="col-sm-6">
        <h1 class="left-text">{{screenTitles.title}}</h1>
    </div>
    <!--
    <div class="col-sm-6">
        <button mat-raised-button id="addWorkRequestBtn" [hidden]="!btnAllowNewRequest" (click)="addWorkRequest()"
            color="primary" type="button" value="submit"><mat-icon>add_box</mat-icon>New Work Request
        </button>
    </div>
    -->
</div>
<mat-card class="card-container">
    <mat-card-header>
        <mat-card-title>
            <span></span>
        </mat-card-title>

        <mat-card-subtitle>
            <span [innerHTML]="screenTitles.instructions"></span>
        </mat-card-subtitle>
    </mat-card-header>

    <div id="filters" *ngIf="screenMode==='admin'">
        <div class="row">

            <div class="buttons-left col-sm-2">
                <so-filtering-multiselect [label]="statusFormFilter.label" [filterName]="statusFormFilter.name"
                    [searchCtrl]="statusFormFilter.searchCtrl" [selectOptions]="statusFormFilter.options"
                    [dataFormCtrl]="statusFormFilter.selectCtrl" [filteredOptions]="statusFormFilter.filteredOptions"
                    [allowSelectAll]="false" (changeEvent)="updateFilterState()">
                </so-filtering-multiselect>
            </div>
            <div class="buttons-left col-sm-2">
                <so-filtering-multiselect [label]="requestTypeFormFilter.label"
                    [filterName]="requestTypeFormFilter.name" [searchCtrl]="requestTypeFormFilter.searchCtrl"
                    [selectOptions]="requestTypeFormFilter.options" [dataFormCtrl]="requestTypeFormFilter.selectCtrl"
                    [filteredOptions]="requestTypeFormFilter.filteredOptions" [allowSelectAll]="false"
                    (changeEvent)="updateFilterState()">
                </so-filtering-multiselect>
            </div>
            <div class="buttons-left col-sm-2">
                <so-filtering-multiselect [label]="consultationTypeFormFilter.label"
                    [filterName]="consultationTypeFormFilter.name" [searchCtrl]="consultationTypeFormFilter.searchCtrl"
                    [selectOptions]="consultationTypeFormFilter.options" [dataFormCtrl]="consultationTypeFormFilter.selectCtrl"
                    [filteredOptions]="consultationTypeFormFilter.filteredOptions" [allowSelectAll]="false"
                    (changeEvent)="updateFilterState()">
                </so-filtering-multiselect>
            </div>       
            <div class="col-sm-2">
                <mat-form-field id='workrequestIdFilter' appearance="fill">
                    <mat-label>Request ID</mat-label>
                    <input matInput placeholder="Work Request ID" [formControl]="filterWorkRequestId"
                        matTooltip="Only the trailing numeric part of the request need be entered but WR00xxx works as well"
                        (change)="updateFilterState()" />
                    <button type="button" *ngIf="filterWorkRequestId.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="clearWorkRequestIdFilter()">
                        <mat-icon>close</mat-icon>
                    </button>

                </mat-form-field>
            </div>
            <div class="col-sm-2">
                <mat-form-field id='requestorFilter' appearance="fill">
                    <mat-label>Requestor</mat-label>
                    <input matInput placeholder="Requestor" [formControl]="filterRequestor"
                        (change)="updateFilterState()" matTooltip="Enter email address or partial email address" />
                    <button type="button" *ngIf="filterRequestor.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="clearRequestorFilter()">
                        <mat-icon>close</mat-icon>
                    </button>

                </mat-form-field>
            </div>
            <div class="col-md-2 col-sm-6" >
                <button class="get-data-btn" mat-raised-button id="get-data" (click)="getWorkRequestListAdmin()"
                    color="primary" type="button" value="submit"><mat-icon>search</mat-icon>Get Data</button>
            </div>

        </div>

    </div>
    <mat-card-content>

        <div class="row" style="margin-top: 15px;">
            <div class="col-md-6">
                <!--
                <so-search-input [formCtrl]="tableFilter" placeHolder="enter search terms"
                  label="Filter Contents">
                </so-search-input>
                -->
           
                <mat-form-field class="full-width search-field" *ngIf="workRequestList.data.length > 0">
                    <mat-label>Table Filter</mat-label>
                    <input [formControl]="tableFilter" matInput placeholder="enter terms to filter displayed work requests" title="enter search terms" />
                    <button type="button" *ngIf="tableFilter.value!==null" 
                      matSuffix mat-icon-button aria-label="Clear"                       
                      (click)="clearSearch()">
                      <mat-icon>close</mat-icon>
                    </button>
                  
                  </mat-form-field>
                  
            </div>

            <div class="buttons-right col-md-6">
                <button type="button" mat-raised-button (click)="exportData('xlsx')">Excel</button>
                <button type="button" mat-raised-button (click)="exportData('csv')">CSV</button>
                <!--button type="button" mat-raised-button (click)="exportData('json')">Json</button
                <button type="button" mat-raised-button (click)="exportData('txt')">Text</button>
                -->


            </div>
        </div>
        <mat-card-header *ngIf="loadingMessage">
            <mat-card-title>
                <span class="alert alert-warning">{{loadingMessage}}</span>
            </mat-card-title>
        </mat-card-header>
        <table mat-table [dataSource]="workRequestList" matSort #workRequestListSort="matSort" matTableExporter
            #exporter="matTableExporter" (exportCompleted)="exportCompleted()" class="mat-elevation-z8">

            <ng-container matColumnDef="wrNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Request </th>
                <td mat-cell  *matCellDef="let workRequest"> {{workRequest.wrNumber}} </td>
            </ng-container>

            <ng-container matColumnDef="requestType">
                <!--suppress HtmlUnknownBooleanAttribute -->
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.requestType}}</td>
            </ng-container>
            <ng-container matColumnDef="requestTypeEnhanced">
                <!--suppress HtmlUnknownBooleanAttribute -->
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                <td mat-cell *matCellDef="let workRequest" [innerHTML]="formatRequestType(workRequest)"></td>
            </ng-container>
            <ng-container matColumnDef="consultationType">
                <!--suppress HtmlUnknownBooleanAttribute -->
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Consultation <br>Type </th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.consultationType}}</td>
            </ng-container>
            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Subject </th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.subject}} </td>
            </ng-container>
            <!--matTooltip="{{workRequest.department}}" matTooltipPosition="left-->
            <ng-container matColumnDef="department">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Department </th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.department}} </td>
            </ng-container>

            <ng-container matColumnDef="azureId">
                <th mat-header-cell *matHeaderCellDef> AzureID </th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.azureId}} </td>

            </ng-container>

            <ng-container matColumnDef="requestorName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requestor </th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.requestorName}} </td>
            </ng-container>

            <ng-container matColumnDef="requestorEmail">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Requestor Email</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.requestorEmail}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
                <td mat-cell *matCellDef="let workRequest"><span> {{workRequest.status}} </span></td>
            </ng-container>

            <ng-container matColumnDef="workRequestId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Request ID</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.workRequestId}} </td>
            </ng-container>

            <ng-container matColumnDef="requestSponsor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sponsor</th>
                <td mat-cell *matCellDef="let workRequest"> {{formatResource(workRequest.sponsors, false)}} </td>
            </ng-container>

            <!--
            <ng-container matColumnDef="requestSponsorEmail">
                <th mat-header-cell *matHeaderCellDef> Sponsor Email</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.requestSponsorEmail}} </td>
            </ng-container>
            -->
            <ng-container matColumnDef="applicationOwner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Application Owner</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.applicationOwner}} </td>
            </ng-container>

            <ng-container matColumnDef="businessRequirements">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Business Requirements</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.businessRequirements}} </td>
            </ng-container>


            <ng-container matColumnDef="desiredOutcome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Desired Outcome</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.desiredOutcome}} </td>
            </ng-container>

            <ng-container matColumnDef="externalInvolvement">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> External Involvement</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.externalInvolvement}} </td>
            </ng-container>
            <ng-container matColumnDef="requestNotes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Request Notes</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.requestNotes}} </td>
            </ng-container>
            <ng-container matColumnDef="partOfSppOpPlan">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Part Of SPP/OP Plan</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.partOfSppOpPlan}} </td>
            </ng-container>

            <ng-container matColumnDef="approvedBudget">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Approved Budget</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.approvedBudget}} </td>
            </ng-container>

            <ng-container matColumnDef="executiveApproval">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Executive Approval</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.executiveApprovaln}} </td>
            </ng-container>

            <ng-container matColumnDef="executiveApprovalName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Executive Approval Name</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.executiveApprovalName}} </td>
            </ng-container>

            <ng-container matColumnDef="registrationRequired">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Registration Required</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.registrationRequired}} </td>
            </ng-container>

            <ng-container matColumnDef="registrationReason">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Registration Reason</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.registrationReason}} </td>
            </ng-container>

            <ng-container matColumnDef="traSosCompleted">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> TRA SOS Completed</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.traSosCompleted}} </td>
            </ng-container>

            <ng-container matColumnDef="sensitivityLevel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sensitivity Level</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.sensitivityLevel}} </td>
            </ng-container>
            <ng-container matColumnDef="piaCompleted">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> PIA Completed</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.piaCompleted}} </td>
            </ng-container>
            <ng-container matColumnDef="applicationType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Application Type</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.applicationType}} </td>
            </ng-container>

            <ng-container matColumnDef="diasterRecoveryNeeded">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Diaster Recovery Needed</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.diasterRecoveryNeeded}} </td>
            </ng-container>
            <ng-container matColumnDef="authenticationMethod">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Authentication Method</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.authenticationMethod}} </td>
            </ng-container>
            <ng-container matColumnDef="numberOfUsers">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Number Of Users</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.numberOfUsers}} </td>
            </ng-container>

            <ng-container matColumnDef="apiRequirements">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> aAPI Requirements</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.apiRequirements}} </td>
            </ng-container>

            <ng-container matColumnDef="publicFacingURLNeeded">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Public Facing URL Needed</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.publicFacingURLNeeded}} </td>
            </ng-container>


            <ng-container matColumnDef="milestones">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Milestones</th>
                <td mat-cell *matCellDef="let workRequest"> {{formatMilestones(workRequest.requestMilestones, false)}} </td>
            </ng-container>

            <ng-container matColumnDef="priorityLevel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Priority</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.priorityLevel}} </td>
            </ng-container>

            <ng-container matColumnDef="ippmStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> IPPM Status</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.ippmStatus}} </td>
            </ng-container>
            <ng-container matColumnDef="numberOfEnvironments">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # Environments</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.numberOfEnvironments}} </td>
            </ng-container>
            <ng-container matColumnDef="numberOfEnvironment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> # Environments</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.numberOfEnvironment}} </td>
            </ng-container>
            <ng-container matColumnDef="tShirtSize">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> T-Shirt Size</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.tShirtSize}} </td>
            </ng-container>
            <ng-container matColumnDef="projectMethodology">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Project Methodology</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectMethodology}} </td>
            </ng-container>

            <ng-container matColumnDef="projectType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Project Type</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectType}} </td>
            </ng-container>
            <ng-container matColumnDef="projectGovernance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Project Governance</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectGovernance}} </td>
            </ng-container>
            <ng-container matColumnDef="fundingSource">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Funding Source</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.fundingSource}} </td>
            </ng-container>
            <ng-container matColumnDef="portfolio">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Portfolio</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.portfolio}} </td>
            </ng-container>
            <ng-container matColumnDef="projectCategory">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Project Category</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectCategory}} </td>
            </ng-container>            
            <ng-container matColumnDef="sppInfo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SPP Info</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.sppInfo}} </td>
            </ng-container>
            <ng-container matColumnDef="checkpoint">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Checkpoint</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.checkpoint}} </td>
            </ng-container>
            <ng-container matColumnDef="trbCheckpoint">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> TRB Checkpoint</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.trbCheckpoint}} </td>
            </ng-container>            
            <ng-container matColumnDef="phaseInfo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Phase Info</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.phaseInfo}} </td>
            </ng-container>
            <ng-container matColumnDef="requestResources">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Request Resources</th>
                <td mat-cell *matCellDef="let workRequest"> {{formatResource(workRequest.requestResources,true)}} </td>
            </ng-container>
            <ng-container matColumnDef="notes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Notes</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.notes}} </td>
            </ng-container>
            <ng-container matColumnDef="resolution">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Resolution</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.resolution}} </td>
            </ng-container>
            <!-- PM Field -->

            <ng-container matColumnDef="projectDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Project Description</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectDescription}} </td>
            </ng-container>

            <ng-container matColumnDef="inScope">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> In Scope</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.inScope}} </td>
            </ng-container>
            <ng-container matColumnDef="outOfScope">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Out Of Scope</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.outOfScope}} </td>
            </ng-container>
            <ng-container matColumnDef="risks">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Risks</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.risks}} </td>
            </ng-container>
            <ng-container matColumnDef="riskMitigation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Risk Mitigation</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.riskMitigation}} </td>
            </ng-container>
            <ng-container matColumnDef="objectives">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Objectives</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.objectives}} </td>
            </ng-container>
            <ng-container matColumnDef="decisions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Decisions</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.decisions}} </td>
            </ng-container>
            <ng-container matColumnDef="keyAccomplishments">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Key Accomplishments</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.keyAccomplishments}} </td>
            </ng-container>
            <ng-container matColumnDef="upcomingActivities">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Upcoming Activities</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.upcomingActivities}} </td>
            </ng-container>
            <ng-container matColumnDef="stakeholderResources">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Stakeholder Resources</th>
                <td mat-cell *matCellDef="let workRequest"> {{formatResource(workRequest.stakeholderResources, true)}} </td>
            </ng-container>


            <ng-container matColumnDef="projectStartDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Start Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectStartDate}} </td>
            </ng-container>
            <ng-container matColumnDef="projectDeliveryDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Delivery Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectDeliveryDate}} </td>
            </ng-container>
            <ng-container matColumnDef="projectRevisionDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Revision Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectRevisionDate}} </td>
            </ng-container>
            <ng-container matColumnDef="projectRevisionReason">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Revision Reason</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectRevisionReason}} </td>
            </ng-container>
            <ng-container matColumnDef="projectStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Status</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.projectStatus}} </td>
            </ng-container>
            <ng-container matColumnDef="previousProjectStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Previous Project Status</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.previousProjectStatus}} </td>
            </ng-container>

            <ng-container matColumnDef="pmMilestones">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Milestones</th>
                <td mat-cell *matCellDef="let workRequest"> {{formatMilestones(workRequest.pmMilestones, true)}} </td>
            </ng-container>

 

            <ng-container matColumnDef="createdDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.createdDateUTC | utcToLocalTime:'short'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="createdDateShort">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.createdDateUTC | utcToLocalTime:'shortDate'}} </td>
            </ng-container>
            
            <ng-container matColumnDef="submittedDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.submittedDateUTC | utcToLocalTime:'short'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="submittedDateShort">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Submitted</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.submittedDateUTC | date}} </td>
            </ng-container>
            <ng-container matColumnDef="internalReviewDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Internal Review Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.internalReviewDateUTC |
                    utcToLocalTime:'short'}} </td>
            </ng-container>
            <ng-container matColumnDef="inProgressDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> In Progress Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.inProgressDateUTC | utcToLocalTime:'short'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="closedDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Closed Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.closedDateUTC | utcToLocalTime:'short'}} </td>
            </ng-container>

            <ng-container matColumnDef="lastModifiedDateUTC">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified Date</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.lastModifiedDateUTC | utcToLocalTime:'short'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="lastModifiedDateShort">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.lastModifiedDateUTC | date}} </td>
            </ng-container>            
            <ng-container matColumnDef="lastModifiedUser">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified User</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.lastModifiedUser}} </td>
            </ng-container>
            <ng-container matColumnDef="lastUserAction">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last User Action</th>
                <td mat-cell *matCellDef="let workRequest"> {{workRequest.lastUserAction}} </td>
            </ng-container>




            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let workRequest">
                    <mat-icon matTooltip="request details" matTooltipPosition="left" class="material-icons"
                        (click)="editWorkRequest(workRequest)"
                        *ngIf="workRequest.wrNumber">{{setRowIcon(workRequest)}}</mat-icon>
                    <mat-icon matTooltip="status report" matTooltipPosition="right" class="material-icons"
                        (click)="gotoWorkRequestStatusReport(workRequest)"
                        *ngIf="workRequest.requestType ==='Project' && workRequest.status !== 'Draft' && workRequest.status !== 'Submitted'  ">assessment</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row (click)="editWorkRequest(row)" [ngClass]="rowClass(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <table id='noDataTable' class="mat-elevation-z8" *ngIf="workRequestList.data.length === 0">
            <caption class='sr-only'> No Records Found.</caption>
            <thead>
                <tr>
                    <th class='sr-only' [attr.colspan]="displayedColumns.length">
                        Message
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr style="height:45px;" >
                    <td [attr.colspan]="displayedColumns.length" *ngIf="queryPerformed">
                        No Records Found.
                    </td>
                    <td [attr.colspan]="displayedColumns.length" *ngIf="!queryPerformed">
                        Enter selection criteria and click 'Get Data'
                    </td>
                </tr>
            </tbody>
        </table>

        <mat-paginator [pageSize]="tablePageSize" [pageSizeOptions]="tablePageSizeOptions" 
        (page)="listingPageSizeChange($event)"> </mat-paginator>

    </mat-card-content>

</mat-card>